export const TENANT_BRANDING = {
  id: 'leblanc',
  name: 'Sanatorio Le Blanc',
  shortName: 'Le Blanc',
  tagline: 'Atención médica integral e internación',
  vertical: 'healthcare-hospital',
  location: 'Ciudad del Este, Alto Paraná, Paraguay',
  phone: '',
  emergency: '',
  hours: {
    weekday: '24/7',
    saturday: '24/7',
    emergency: 'Urgencias 24/7'
  },
  domains: []
};
